export enum TripsFilter {
  Upcoming = 'UPCOMING',
  Past = 'PAST'
}
